module.exports = __webpack_public_path__ + "img/mockup.5d57543f.png";